<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New User</ng-container>
  <ng-container *ngIf="data.id">Edit User</ng-container>
</h1>
<mat-dialog-content>

  <aw-user-form [user]="data" (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"></aw-user-form>

</mat-dialog-content>
